function OffenderScheduleCache(aSchedule) {
//    "use strict";
//    this.__type = 'OffenderSchedule:www.veritracks.com';
//    this.Id = aSchedule.Id;
//    this.Version = aSchedule.Version;

//    this.EndTime = aSchedule.EndTime;
//    this.EnrolleeId = aSchedule.EnrolleeId;
//    this.EntityId = aSchedule.EntityId;
//    this.IsActive = aSchedule.IsActive;
//    this.IsForcedLeave = aSchedule.IsForcedLeave;
//    this.IsFriday = aSchedule.IsFriday;
//    this.IsMonday = aSchedule.IsMonday;
//    this.IsNoSchedule = aSchedule.IsNoSchedule;
//    this.IsRecurring = aSchedule.IsRecurring;
//    this.IsSaturday = aSchedule.IsSaturday;
//    this.IsSunday = aSchedule.IsSunday;
//    this.IsThursday = aSchedule.IsThursday;
//    this.IsTuesday = aSchedule.IsTuesday;
//    this.IsWednesday = aSchedule.IsWednesday;
//    this.Name = aSchedule.Name;
//    this.ScheduleType = aSchedule.ScheduleType;
//    this.StartTime = aSchedule.StartTime;

//    if (this.StartTime.getDay() !== this.StartTime.getUTCDay()) {
//        if (aSchedule.IsSunday) {
//            this.IsSunday = false;
//            this.IsSaturday = true;
//        }
//        if (aSchedule.IsMonday) {
//            this.IsMonday = false;
//            this.IsSunday = true;
//        }
//        if (aSchedule.IsTuesday) {
//            this.IsTuesday = false;
//            this.IsMonday = true;
//        }
//        if (aSchedule.IsWednesday) {
//            this.IsWednesday = false;
//            this.IsTuesday = true;
//        }
//        if (aSchedule.IsThursday) {
//            this.IsThursday = false;
//            this.IsWednesday = true;
//        }
//        if (aSchedule.IsFriday) {
//            this.IsFriday = false;
//            this.IsThursday = true;
//        }
//        if (aSchedule.IsSaturday) {
//            this.IsSaturday = false;
//            this.IsFriday = true;
//        }
//    }
}
if (typeof exports !== 'undefined') {
    module.exports = OffenderScheduleCache;
}